import { css } from '@emotion/react';
import { links } from 'folio-common-components';
import { isObject } from 'folio-common-utils';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, ButtonLink } from '../../components/buttons';
import { useIntercomControls } from '../../components/intercom/intercom-context';
import { PageHeading } from '../../components/page-heading';
import { pageMap } from '../../paths';

export const nonRetryableErrors = [
  'check-folkeregisteret',
  'prekontroll-other',
];

const PreControlFeedback: React.FC = () => {
  const { state } = useLocation();
  const intercom = useIntercomControls();

  if (isObject(state)) {
    switch (state.error) {
      case 'check-folkeregisteret':
        return (
          <ErrorScreen>
            <p>
              Dobbeltsjekk at alle eierne er myndige, og at de har oppgitt en
              adresse som samsvarer med den i Folkeregisteret.
            </p>
            <ButtonLink
              href="https://www.skatteetaten.no/skjema/opplysninger-i-folkeregisteret/"
              target="_blank"
            >
              Sjekk Folkeregisteret
            </ButtonLink>
          </ErrorScreen>
        );

      case 'prekontroll-other':
        return (
          <ErrorScreen>
            <p>Ta kontakt med oss, så nøster vi opp i problemet.</p>
            <Button onClick={intercom.show}>Kontakt oss</Button>
          </ErrorScreen>
        );
    }
  }

  // This should never happen, just show a link back to the form
  return <ErrorScreen />;
};

const ErrorScreen: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div
      css={css`
        text-align: center;
        text-wrap: balance;
      `}
    >
      <PageHeading>Noe gikk galt</PageHeading>
      {children}
      <p>
        <Link
          to={{ pathname: pageMap.step5, search: window.location.search }}
          css={links.blackLink}
        >
          Tilbake til skjemaet
        </Link>
      </p>
    </div>
  );
};

// React.lazy only supports default exports:
// https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default PreControlFeedback;
